.zone {
	background-color: var(--lp-color-bg-ui-secondary);
	border: 1px solid var(--lp-color-border-ui-primary);
	border-radius: var(--lp-border-radius-medium);
	align-items: center;
	justify-content: center;
	margin: 0;
	outline: none;
	padding: var(--lp-spacing-500) var(--lp-spacing-700);
	display: inline-flex;
	flex-direction: column;
	gap: var(--lp-spacing-400);

	&[data-focus-visible],
	&[data-drop-target] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 2;
	}

	&[data-drop-target] {
		background-color: var(--lp-color-bg-interactive-selected);
	}

	&[data-disabled] {
		opacity: 0.64;
	}
}
